import { StyleSheet } from "react-native";
import { typography } from '@shared/config/typographyConfig';

const tabNavigatorStyle = StyleSheet.create({
    tabBar: {
        backgroundColor: '#FFFFFF',
        borderTopWidth: 1,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderTopColor: '#E5E7EB',
        borderLeftColor: '#E5E7EB',
        borderRightColor: '#E5E7EB',
        paddingVertical: 20,
        borderTopLeftRadius: 32,
        borderTopRightRadius: 32,
        overflow: 'hidden',
        height: 90,
    },
    tabBarItem: {
        paddingVertical: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    tabBarIcon: {
        height: 40,
        width: 40,
        alignItems: 'center',
        justifyContent: 'center',
    },
    tabBarLabel: {
        fontSize: typography.fontSize.base,
        fontWeight: '500',
    },
});

export default tabNavigatorStyle;